export default __webpack_public_path__ + "static/media/user_edited.ebdebc91.svg";